export default __webpack_public_path__ + "static/media/Opposites02_03.3ae50f74.png";